import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class cuentasCobrarService {

    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}tesoreria/centro-costo`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listar_estados() {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/estado`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async listar_estados_cuentas() {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/estadoCuentas`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async cuentasResumen(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/resumen?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async cuentasCredito(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/credito?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async cuentasDetallado(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/detallado?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async ver(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/ver?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async verPago(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/ver_pago?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async dashboardDeuda(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/dashboard-deuda?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async dashboardTotal(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/dashboard-cobranza-total?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async dashboardTotalVencidos(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/dashboard-cobranza-vencido?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/pdf-ticket?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket50(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/pdf-ticket-50?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };



    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excelResumen(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/excelResumen?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdfResumen(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-cobrar/pdfResumen?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}tesoreria/cuentas-cobrar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };




}

export default new cuentasCobrarService();